import store from "@/state/store";

export default [
    {
        path: "/",
        name: "home",
        meta: {
            authRequired: true,
            translate: (t) => {
                return t('menu_points.home').ucFirst();
            },
        },
        redirect: {name: 'portal-dashboard'},
        component: () => import("../views/layouts/vertical.vue"),
        children: [
            {
                path: 'dashboard',
                name: 'portal-dashboard',
                meta: {
                    translate: (t) => t('menu_points.dashboard').ucFirst(),
                    type: 'tenant'
                },
                component: () => import("../views/pages/portal/dashboard.vue"),
            },
            {
                path: 'my-appointments',
                name: 'portal-my-appointments',
                meta: {
                    translate: (t) => t('menu_points.my_appointments').ucFirst(),
                    type: 'tenant',
                },
                component: () => import("../views/pages/portal/appointments.vue"),
            },
            {
                path: 'join-consultation',
                name: 'portal-join-consultation',
                meta: {
                    translate: (t) => t('menu_points.join_consultation').ucFirst(),
                    type: 'tenant',
                },
                component: () => import("../views/pages/portal/join-consultation.vue"),
            },
            {
                path: 'documents',
                name: 'portal-documents',
                meta: {
                    translate: (t) => t('menu_points.documents').ucFirst(),
                    type: 'tenant',
                },
                component: () => import("../views/pages/portal/documents.vue"),
            },
            {
                path: 'prescriptions',
                name: 'portal-prescriptions',
                meta: {
                    portalComingSoon: true,
                    translate: (t) => t('menu_points.prescriptions').ucFirst(),
                    type: 'tenant',
                },
                component: () => import("../views/pages/portal/prescriptions.vue"),
            },
            {
                path: 'waiting-list',
                name: 'portal-waiting-list',
                meta: {
                    portalComingSoon: true,
                    translate: (t) => t('menu_points.portal_waiting_list').ucFirst(),
                    type: 'tenant',
                },
                component: () => import("../views/pages/portal/waiting-list.vue"),
            },
            {
                path: 'assessment-forms',
                name: 'portal-assessment-forms',
                meta: {
                    translate: (t) => t('menu_points.assessment_forms').ucFirst(),
                    type: 'tenant',
                },
                component: () => import("../views/pages/portal/assessment-forms.vue"),
            },
            {
                path: 'webshop',
                name: 'portal-webshop',
                meta: {
                    portalComingSoon: true,
                    translate: (t) => t('menu_points.webshop').ucFirst(),
                    type: 'tenant',
                },
                component: () => import("../views/pages/portal/webshop.vue"),
            },
            {
                path: 'webshop/products/:model',
                name: 'portal-webshop-product',
                meta: {
                    portalComingSoon: true,
                    translate: (t) => t('menu_points.webshop').ucFirst(),
                    type: 'tenant',
                    permissionRoute: '/webshop',
                },
                component: () => import("../views/pages/portal/webshop-product.vue"),
            },
            {
                path: 'webshop/cart',
                name: 'portal-webshop-cart',
                meta: {
                    portalComingSoon: true,
                    translate: (t) => t('menu_points.webshop').ucFirst(),
                    type: 'tenant',
                    permissionRoute: '/webshop',
                },
                component: () => import("../views/pages/portal/webshop-cart.vue"),
            },
            {
                path: 'webshop/checkout',
                name: 'portal-webshop-checkout',
                meta: {
                    portalComingSoon: true,
                    translate: (t) => t('menu_points.webshop').ucFirst(),
                    type: 'tenant',
                    permissionRoute: '/webshop',
                },
                component: () => import("../views/pages/portal/webshop-checkout.vue"),
            },
            {
                path: 'orders',
                name: 'portal-orders',
                meta: {
                    portalComingSoon: true,
                    translate: (t) => t('menu_points.orders').ucFirst(),
                    type: 'tenant',
                },
                component: () => import("../views/pages/portal/orders.vue"),
            },
            {
                path: 'health-path',
                name: 'portal-health-path',
                meta: {
                    portalComingSoon: true,
                    translate: (t) => t('menu_points.health_path').ucFirst(),
                    type: 'tenant',
                },
                component: () => import("../views/pages/empty.vue"),
            },
            {
                path: 'knowledge-base',
                name: 'portal-knowledge-base',
                meta: {
                    portalComingSoon: true,
                    translate: (t) => t('menu_points.knowledge_base').ucFirst(),
                    type: 'tenant',
                },
                component: () => import("../views/pages/portal/knowledge-base.vue"),
            },
            {
                path: 'messages',
                name: 'portal-messages',
                meta: {
                    translate: (t) => t('menu_points.messages').ucFirst(),
                    type: 'tenant',
                },
                component: () => import("../views/pages/portal/messages.vue"),
            },
            {
                path: 'profile',
                name: 'portal-profile',
                meta: {
                    translate: (t) => t('profile.title').ucFirst(),
                    type: 'tenant',
                },
                component: () => import("../views/pages/portal/profile.vue"),
            },

            // =========================
            // APPLICATION
            // =========================

            {
                path: 'application',
                name: 'application',
                component: () => import('../views/helpers/grouper/grouper.vue'),
                meta: {
                    translate: (t) => t('menu_points.application').ucFirst(),
                    type: 'tenant'
                },
                children: [

                    // Dashboard
                    {
                        path: 'dashboard',
                        name: 'application-dashboard',
                        meta: {
                            translate: (t) => t('menu_points.application_dashboard').ucFirst()
                        },
                        component: () => import("../views/pages/empty.vue"),
                    },

                    // Páciensek
                    {
                        path: 'patients',
                        name: 'application-patients',
                        component: () => import('../views/helpers/grouper/grouper.vue'),
                        meta: {
                            translate: (t) => t('menu_points.application_patients').ucFirst()
                        },
                        children: [
                            {
                                path: 'patients',
                                name: 'application-patients-patients',
                                meta: {
                                    translate: (t) => t('menu_points.application_patients_patients').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            }
                        ]
                    },

                    // Előjegyzések
                    {
                        path: 'appointments',
                        name: 'application-appointments',
                        component: () => import('../views/helpers/grouper/grouper.vue'),
                        meta: {
                            translate: (t) => t('menu_points.application_appointments').ucFirst()
                        },
                        children: [
                            {
                                path: 'appointments',
                                name: 'application-appointments-appointments',
                                meta: {
                                    translate: (t) => t('menu_points.application_appointments_appointments').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            },
                            {
                                path: 'my-appointments',
                                name: 'application-appointments-my-appointments',
                                meta: {
                                    translate: (t) => t('menu_points.application_appointments_my_appointments').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            }
                        ]
                    },

                    // Rendelési idők
                    {
                        path: 'schedules',
                        name: 'application-schedules',
                        component: () => import('../views/helpers/grouper/grouper.vue'),
                        meta: {
                            translate: (t) => t('menu_points.application_schedules').ucFirst()
                        },
                        children: [
                            {
                                path: 'schedules',
                                name: 'application-schedules-schedules',
                                meta: {
                                    translate: (t) => t('menu_points.application_schedules_schedules').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            },
                            {
                                path: 'holidays',
                                name: 'application-schedules-holidays',
                                meta: {
                                    translate: (t) => t('menu_points.application_schedules_holidays').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            },
                            {
                                path: 'doctors-holidays',
                                name: 'application-schedules-doctors-holidays',
                                meta: {
                                    translate: (t) => t('menu_points.application_schedules_doctors_holidays').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            },
                            {
                                path: 'categories',
                                name: 'application-schedules-categories',
                                meta: {
                                    translate: (t) => t('menu_points.application_schedules_categories').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            },
                            {
                                path: 'rooms',
                                name: 'application-schedules-rooms',
                                meta: {
                                    translate: (t) => t('menu_points.application_schedules_rooms').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            }
                        ]
                    },

                    // Felhasználók
                    {
                        path: 'users',
                        name: 'application-users',
                        component: () => import('../views/helpers/grouper/grouper.vue'),
                        meta: {
                            translate: (t) => t('menu_points.application_users').ucFirst()
                        },
                        children: [
                            {
                                path: 'nurses',
                                name: 'application-users-nurses',
                                meta: {
                                    translate: (t) => t('menu_points.application_users_nurses').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            },
                            {
                                path: 'doctors',
                                name: 'application-users-doctors',
                                meta: {
                                    translate: (t) => t('menu_points.application_users_doctors').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            },
                            {
                                path: 'users',
                                name: 'application-users-users',
                                meta: {
                                    translate: (t) => t('menu_points.application_users_users').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            }
                        ]
                    },

                    // Vállalati együttműködések
                    {
                        path: 'partners',
                        name: 'application-partners',
                        component: () => import('../views/helpers/grouper/grouper.vue'),
                        meta: {
                            translate: (t) => t('menu_points.application_partners').ucFirst()
                        },
                        children: [
                            {
                                path: 'companies',
                                name: 'application-partners-companies',
                                meta: {
                                    translate: (t) => t('menu_points.application_partners_companies').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            },
                            {
                                path: 'contracts',
                                name: 'application-partners-contracts',
                                meta: {
                                    translate: (t) => t('menu_points.application_partners_contracts').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            },
                            {
                                path: 'employees',
                                name: 'application-partners-employees',
                                meta: {
                                    translate: (t) => t('menu_points.application_partners_employees').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            },
                            {
                                path: 'company-reports',
                                name: 'application-partners-company-reports',
                                meta: {
                                    translate: (t) => t('menu_points.application_partners_company_reports').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            },
                        ]
                    },

                    // Riportok
                    {
                        path: 'reports',
                        name: 'application-reports',
                        component: () => import('../views/helpers/grouper/grouper.vue'),
                        meta: {
                            translate: (t) => t('menu_points.application_reports').ucFirst()
                        },
                        children: [
                            {
                                path: 'financial',
                                name: 'application-reports-financial',
                                meta: {
                                    translate: (t) => t('menu_points.application_reports_financial').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            },
                            {
                                path: 'marketing',
                                name: 'application-reports-marketing',
                                meta: {
                                    translate: (t) => t('menu_points.application_reports_marketing').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            },
                            {
                                path: 'patient',
                                name: 'application-reports-patient',
                                meta: {
                                    translate: (t) => t('menu_points.application_reports_patient').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            },
                            {
                                path: 'custom',
                                name: 'application-reports-custom',
                                meta: {
                                    translate: (t) => t('menu_points.application_reports_custom').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            },
                            {
                                path: 'system',
                                name: 'application-reports-system',
                                meta: {
                                    translate: (t) => t('menu_points.application_reports_system').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            }
                        ]
                    },

                    // Kommunikáció
                    {
                        path: 'communication',
                        name: 'application-communication',
                        component: () => import('../views/helpers/grouper/grouper.vue'),
                        meta: {
                            translate: (t) => t('menu_points.application_communication').ucFirst()
                        },
                        children: [
                            {
                                path: 'email',
                                name: 'application-communication-email',
                                meta: {
                                    translate: (t) => t('menu_points.application_communication_email').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            },
                            {
                                path: 'sms',
                                name: 'application-communication-sms',
                                meta: {
                                    translate: (t) => t('menu_points.application_communication_sms').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            },
                            {
                                path: 'patient-satisfaction',
                                name: 'application-communication-patient-satisfaction',
                                meta: {
                                    translate: (t) => t('menu_points.application_communication_patient_satisfaction').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            }
                        ]
                    },

                    // Jogosultságkezelés
                    {
                        path: 'permissions',
                        name: 'application-permissions',
                        component: () => import('../views/helpers/grouper/grouper.vue'),
                        meta: {
                            translate: (t) => t('menu_points.application_permissions').ucFirst()
                        },
                        children: [
                            {
                                path: 'management',
                                name: 'application-permissions-management',
                                meta: {
                                    translate: (t) => t('menu_points.application_permission_management').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            }
                        ]
                    }
                ]
            },

            // =========================
            // MASTER DATA
            // =========================
            {
                path: 'master-data',
                name: 'master-data',
                component: () => import('../views/helpers/grouper/grouper.vue'),
                meta: {
                    translate: (t) => t('menu_points.master_data').ucFirst(),
                    type: 'tenant'
                },
                children: [
                    // Kérdőívek
                    {
                        path: 'questionnaires',
                        name: 'master-data-questionnaires',
                        component: () => import('../views/helpers/grouper/grouper.vue'),
                        meta: {
                            translate: (t) => t('menu_points.master_data_questionnaires').ucFirst()
                        },
                        children: [
                            {
                                path: 'patient-satisfaction',
                                name: 'master-data-questionnaires-patient-satisfaction',
                                meta: {
                                    translate: (t) => t('menu_points.master_data_questionnaires_patient_satisfaction').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            },
                            {
                                path: 'status-assessment',
                                name: 'master-data-questionnaires-status-assessment',
                                meta: {
                                    translate: (t) => t('menu_points.master_data_questionnaires_status_assessment').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            }
                        ]
                    },

                    // Számlázási törzsadatok
                    {
                        path: 'billing',
                        name: 'master-data-billing',
                        component: () => import('../views/helpers/grouper/grouper.vue'),
                        meta: {
                            translate: (t) => t('menu_points.master_data_billing').ucFirst()
                        },
                        children: [
                            {
                                path: 'services',
                                name: 'master-data-billing-services',
                                meta: {
                                    translate: (t) => t('menu_points.master_data_billing_services').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            },
                            {
                                path: 'customer-card-types',
                                name: 'master-data-billing-customer-card-types',
                                meta: {
                                    translate: (t) => t('menu_points.master_data_billing_customer_card_types').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            }
                        ]
                    },

                    // Rendelési törzsadatok
                    {
                        path: 'schedules',
                        name: 'master-data-schedules',
                        component: () => import('../views/helpers/grouper/grouper.vue'),
                        meta: {
                            translate: (t) => t('menu_points.master_data_schedules').ucFirst()
                        },
                        children: [
                            {
                                path: 'schedules',
                                name: 'master-data-schedules-schedules',
                                meta: {
                                    translate: (t) => t('menu_points.master_data_schedules_schedules').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            },
                            {
                                path: 'holidays',
                                name: 'master-data-schedules-holidays',
                                meta: {
                                    translate: (t) => t('menu_points.master_data_schedules_holidays').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            },
                            {
                                path: 'doctors-holidays',
                                name: 'master-data-schedules-doctors-holidays',
                                meta: {
                                    translate: (t) => t('menu_points.master_data_schedules_doctors_holidays').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            },
                            {
                                path: 'categories',
                                name: 'master-data-schedules-categories',
                                meta: {
                                    translate: (t) => t('menu_points.master_data_schedules_categories').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            }
                        ]
                    },

                    // Szervezeti törzsadatok
                    {
                        path: 'organization',
                        name: 'master-data-organization',
                        component: () => import('../views/helpers/grouper/grouper.vue'),
                        meta: {
                            translate: (t) => t('menu_points.master_data_organizations').ucFirst()
                        },
                        children: [
                            {
                                path: 'locations',
                                name: 'master-data-organizations-locations',
                                meta: {
                                    translate: (t) => t('menu_points.master_data_organizations_locations').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            },
                            {
                                path: 'departments',
                                name: 'master-data-organizations-departments',
                                meta: {
                                    translate: (t) => t('menu_points.master_data_organizations_departments').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            },
                            {
                                path: 'rooms',
                                name: 'master-data-organizations-rooms',
                                meta: {
                                    translate: (t) => t('menu_points.master_data_organizations_rooms').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            },
                            {
                                path: 'operating-rooms',
                                name: 'master-data-organizations-operating-rooms',
                                meta: {
                                    translate: (t) => t('menu_points.master_data_organizations_operating_rooms').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            },
                            {
                                path: 'unit-codes',
                                name: 'master-data-organizations-unit-codes',
                                meta: {
                                    translate: (t) => t('menu_points.master_data_organizations_unit_codes').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            }
                        ]
                    }
                ]
            },

            // =========================
            // SYSTEM
            // =========================

            {
                path: 'system',
                name: 'system',
                component: () => import('../views/helpers/grouper/grouper.vue'),
                meta: {
                    translate: (t) => t('menu_points.system').ucFirst(),
                    type: 'global'
                },
                children: [

                    // -------------------------
                    // PÁCIENSEK
                    // -------------------------
                    {
                        path: 'patients',
                        name: 'system-patients',
                        component: () => import('../views/helpers/grouper/grouper.vue'),
                        meta: {
                            translate: (t) => t('menu_points.system_patients').ucFirst()
                        },
                        children: [
                            {
                                path: 'all',
                                name: 'system-patients-all',
                                meta: {
                                    translate: (t) => t('menu_points.system_patients_all').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            },
                            {
                                path: 'merge',
                                name: 'system-patients-merge',
                                meta: {
                                    translate: (t) => t('menu_points.system_patients_merge').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            }
                        ]
                    },

                    // -------------------------
                    // TÖRZSADATOK
                    // -------------------------
                    {
                        path: 'master-data',
                        name: 'system-master-data',
                        component: () => import('../views/helpers/grouper/grouper.vue'),
                        meta: {
                            translate: (t) => t('menu_points.system_master_data').ucFirst()
                        },
                        children: [

                            // Globál szolgáltatástörzs
                            {
                                path: 'global-services',
                                name: 'system-master-data-global-services',
                                meta: {
                                    translate: (t) => t('menu_points.system_master_data_global_services').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            },

                            // -------------------------
                            // CÍMADATOK
                            // -------------------------
                            {
                                path: 'address',
                                name: 'system-master-data-address',
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                meta: {
                                    translate: (t) => t('menu_points.system_master_data_location').ucFirst()
                                },
                                children: [
                                    {
                                        path: "address-types",
                                        name: 'address-types',
                                        component: () => import('../views/helpers/grouper/grouper.vue'), // vagy külön layout
                                        meta: {
                                            translate: (t, tc) => tc('master::address_types.address_type', 2).ucFirst()
                                        },
                                        redirect: { name: 'address-types-list'},
                                        children: [
                                            {
                                                path: '',
                                                name: 'address-types-list',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return tc('master::address_types.address_type', 2).ucFirst();
                                                    }
                                                },
                                                component: () => import('../views/pages/addresses/address-types/list.vue')
                                            },
                                            {
                                                path: 'create',
                                                name: 'address-type-create',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.create_new_item', {item: tc('master::address_types.address_type', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/addresses/address-types/item.vue')
                                            },
                                            {
                                                path: ':id(\\d+)',
                                                name: 'address-type-edit',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.edit_item', {item: tc('master::address_types.address_type', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/addresses/address-types/item.vue')
                                            },
                                        ]
                                    },
                                    {
                                        path: 'countries',
                                        name: 'countries',
                                        component: () => import('../views/helpers/grouper/grouper.vue'), // vagy külön layout
                                        meta: {
                                            translate: (t, tc) => tc('master::countries.country', 2).ucFirst()
                                        },
                                        redirect: { name: 'countries-list'},
                                        children: [
                                            {
                                                path: '',
                                                name: 'countries-list',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return tc('master::countries.country', 2).ucFirst();
                                                    }
                                                },
                                                component: () => import('../views/pages/addresses/countries/list.vue')
                                            },
                                            {
                                                path: 'create',
                                                name: 'country-create',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.create_new_item', {item: tc('master::countries.country', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/addresses/countries/item.vue')
                                            },
                                            {
                                                path: ':id(\\d+)',
                                                name: 'country-edit',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.edit_item', {item: tc('master::countries.country', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/addresses/countries/item.vue')
                                            },
                                        ]
                                    },
                                    {
                                        path: 'zip-codes',
                                        name: 'zip-codes',
                                        meta: {
                                            translate: (t, tc) => {
                                                return tc('master::zip_codes.zip_code', 2).ucFirst();
                                            },
                                        },
                                        component: () => import('../views/helpers/grouper/grouper.vue'),
                                        redirect: { name: 'zip-codes-list'},
                                        children: [
                                            {
                                                path: '',
                                                name: 'zip-codes-list',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return tc('master::zip_codes.zip_code', 2).ucFirst();
                                                    }
                                                },
                                                component: () => import('../views/pages/addresses/zip-codes/list.vue')
                                            },
                                            {
                                                path: 'create',
                                                name: 'zip-code-create',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.create_new_item', {item: tc('master::zip_codes.zip_code', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/addresses/zip-codes/item.vue')
                                            },
                                            {
                                                path: ':id(\\d+)',
                                                name: 'zip-code-edit',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.edit_item', {item: tc('master::zip_codes.zip_code', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/addresses/zip-codes/item.vue')
                                            },
                                        ]
                                    },
                                    {
                                        path: 'street-types',
                                        name: 'street-types',
                                        meta: {
                                            translate: (t, tc) => {
                                                return tc('master::street_types.street_type', 2).ucFirst();
                                            },
                                        },
                                        redirect: { name: 'street-types-list'},
                                        component: () => import('../views/helpers/grouper/grouper.vue'),
                                        children: [
                                            {
                                                path: '',
                                                name: 'street-types-list',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return tc('master::street_types.street_type', 2).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/addresses/street-types/list.vue')
                                            },
                                            {
                                                path: 'create',
                                                name: 'street-type-create',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.create_new_item', {item: tc('master::street_types.street_type', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/addresses/street-types/item.vue')
                                            },
                                            {
                                                path: ':id(\\d+)',
                                                name: 'street-type-edit',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.edit_item', {item: tc('master::street_types.street_type', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/addresses/street-types/item.vue')
                                            },
                                        ]
                                    },
                                ]
                            },

                            // -------------------------
                            // SZEMÉLYI ATTRIBÚTUMOK
                            // -------------------------
                            {
                                path: 'personal-attributes',
                                name: 'system-master-data-personal-attributes',
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                meta: {
                                    translate: (t) => t('menu_points.system_master_data_personal_attributes').ucFirst()
                                },
                                children: [

                                    {
                                        path: "genders",
                                        name: "genders",
                                        component: () => import('../views/helpers/grouper/grouper.vue'),
                                        meta: {
                                            translate: (t, tc) => tc('master::genders.gender', 2).ucFirst()
                                        },
                                        redirect: {name: 'genders-list'},
                                        children: [
                                            {
                                                path: '',
                                                name: 'genders-list',
                                                meta: {
                                                    translate: (t, tc) => tc('master::genders.gender', 2).ucFirst()
                                                },
                                                component: () => import('../views/pages/organizations/genders/list.vue')
                                            },
                                            {
                                                path: 'create',
                                                name: 'gender-create',
                                                meta: {
                                                    translate: (t, tc) =>
                                                        t('base.create_new_item', {item: tc('master::genders.gender', 1)}).ucFirst()
                                                },
                                                component: () => import('../views/pages/organizations/genders/item.vue')
                                            },
                                            {
                                                path: ':id(\\d+)',
                                                name: 'gender-edit',
                                                meta: {
                                                    translate: (t, tc) =>
                                                        t('base.edit_item', {item: tc('master::genders.gender', 1)}).ucFirst()
                                                },
                                                component: () => import('../views/pages/organizations/genders/item.vue')
                                            }
                                        ]
                                    },
                                ]
                            },

                            // -------------------------
                            // SZÁMLÁZÁSI TÖRZSADATOK
                            // -------------------------
                            {
                                path: 'billing',
                                name: 'system-master-data-billing',
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                meta: {
                                    translate: (t) => t('menu_points.system_master_data_billing').ucFirst()
                                },
                                children: [
                                    {
                                        path: 'vat',
                                        name: 'system-master-data-billing-vat',
                                        meta: {
                                            translate: (t) => t('menu_points.system_master_data_billing_vat').ucFirst()
                                        },
                                        component: () => import('../views/helpers/grouper/grouper.vue'),
                                        redirect: { name: 'vatCategories-list'},
                                        children: [
                                            {
                                                path: '',
                                                name: 'vatCategories-list',
                                                meta: {
                                                    translate: (t) => t('menu_points.system_master_data_billing_vat').ucFirst()
                                                },
                                                component: () => import('../views/pages/vatCategories/list.vue')
                                            },
                                            {
                                                path: 'create',
                                                name: 'vatCategories-vatCategory-create',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.create_new_item', {item: tc('financial::vatCategories.vatCategory', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/vatCategories/page.vue')
                                            },
                                            {
                                                path: ':id(\\d+)',
                                                name: 'vatCategories-vatCategory-edit',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.edit_item', {item: tc('financial::vatCategories.vatCategory', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/vatCategories/page.vue')
                                            },
                                        ]
                                    },
                                    {
                                        path: 'units',
                                        name: 'system-master-data-billing-units',
                                        meta: {
                                            translate: (t) => t('menu_points.system_master_data_billing_units').ucFirst()
                                        },
                                        component: () => import('../views/helpers/grouper/grouper.vue'),
                                        redirect: { name: 'units-list'},
                                        children: [
                                            {
                                                path: '',
                                                name: 'units-list',
                                                meta: {
                                                    translate: (t) => t('menu_points.system_master_data_billing_units').ucFirst()
                                                },
                                                component: () => import('../views/pages/units/list.vue')
                                            },
                                            {
                                                path: 'create',
                                                name: 'units-unit-create',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.create_new_item', {item: tc('financial::units.unit', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/units/page.vue')
                                            },
                                            {
                                                path: ':id(\\d+)',
                                                name: 'units-unit-edit',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.edit_item', {item: tc('financial::units.unit', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/units/page.vue')
                                            },
                                        ]
                                    },
                                    {
                                        path: 'payment-methods',
                                        name: 'system-master-data-billing-payment-methods',
                                        meta: {
                                            translate: (t) => t('menu_points.system_master_data_billing_payment_methods').ucFirst()
                                        },
                                        component: () => import('../views/helpers/grouper/grouper.vue'),
                                        redirect: { name: 'paymentModes-list'},
                                        children: [
                                            {
                                                path: '',
                                                name: 'paymentModes-list',
                                                meta: {
                                                    translate: (t) => t('menu_points.system_master_data_billing_payment_methods').ucFirst()
                                                },
                                                component: () => import('../views/pages/paymentModes/list.vue')
                                            },
                                            {
                                                path: 'create',
                                                name: 'paymentModes-paymentMode-create',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.create_new_item', {item: tc('financial::paymentModes.paymentMode', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/paymentModes/page.vue')
                                            },
                                            {
                                                path: ':id(\\d+)',
                                                name: 'paymentModes-paymentMode-edit',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.edit_item', {item: tc('financial::paymentModes.paymentMode', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/paymentModes/page.vue')
                                            },
                                        ]
                                    },
                                    {
                                        path: 'health-funds',
                                        name: 'system-master-data-billing-health-funds',
                                        meta: {
                                            translate: (t) => t('menu_points.system_master_data_billing_health_funds').ucFirst()
                                        },
                                        component: () => import('../views/helpers/grouper/grouper.vue'),
                                        redirect: { name: 'healthFunds-list'},
                                        children: [
                                            {
                                                path: '',
                                                name: 'healthFunds-list',
                                                meta: {
                                                    translate: (t) => t('menu_points.system_master_data_billing_health_funds').ucFirst()
                                                },
                                                component: () => import('../views/pages/healthFunds/list.vue')
                                            },
                                            {
                                                path: 'create',
                                                name: 'healthFunds-healthFund-create',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.create_new_item', {item: tc('financial::healthFunds.healthFund', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/healthFunds/page.vue')
                                            },
                                            {
                                                path: ':id(\\d+)',
                                                name: 'healthFunds-healthFund-edit',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.edit_item', {item: tc('financial::healthFunds.healthFund', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/healthFunds/page.vue')
                                            },
                                        ]
                                    },
                                    {
                                        path: 'health-insurances',
                                        name: 'system-master-data-billing-health-insurances',
                                        meta: {
                                            translate: (t) => t('menu_points.system_master_data_medical_health_insurances').ucFirst()
                                        },
                                        component: () => import('../views/helpers/grouper/grouper.vue'),
                                        redirect: { name: 'healthInsurances-list'},
                                        children: [
                                            {
                                                path: '',
                                                name: 'healthInsurances-list',
                                                meta: {
                                                    translate: (t) => t('menu_points.system_master_data_medical_health_insurances').ucFirst()
                                                },
                                                component: () => import('../views/pages/healthInsurances/list.vue')
                                            },
                                            {
                                                path: 'create',
                                                name: 'healthInsurances-healthInsurance-create',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.create_new_item', {item: tc('financial::healthInsurances.healthInsurance', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/healthInsurances/page.vue')
                                            },
                                            {
                                                path: ':id(\\d+)',
                                                name: 'healthInsurances-healthInsurance-edit',
                                                meta: {
                                                    translate: (t, tc) => {
                                                        return t('base.edit_item', {item: tc('financial::healthInsurances.healthInsurance', 1)}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/healthInsurances/page.vue')
                                            },
                                        ]
                                    }
                                ]
                            },

                            // -------------------------
                            // EGÉSZSÉGÜGYI TÖRZSADATOK
                            // -------------------------
                            {
                                path: 'medical',
                                name: 'system-master-data-medical',
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                meta: {
                                    translate: (t) => t('menu_points.system_master_data_medical').ucFirst()
                                },
                                children: [
                                    {
                                        path: 'bno',
                                        name: 'system-master-data-medical-bno',
                                        meta: {
                                            translate: (t) => t('menu_points.system_master_data_medical_bno').ucFirst()
                                        },
                                        component: () => import("../views/pages/empty.vue"),
                                    },
                                    {
                                        path: 'cpt',
                                        name: 'system-master-data-medical-cpt',
                                        meta: {
                                            translate: (t) => t('menu_points.system_master_data_medical_cpt').ucFirst()
                                        },
                                        component: () => import("../views/pages/empty.vue"),
                                    },
                                    {
                                        path: 'health-funds',
                                        name: 'system-master-data-medical-health-funds',
                                        meta: {
                                            translate: (t) => t('menu_points.system_master_data_medical_health_funds').ucFirst()
                                        },
                                        component: () => import("../views/pages/empty.vue"),
                                    },
                                    {
                                        path: 'health-insurances',
                                        name: 'system-master-data-medical-health-insurances',
                                        meta: {
                                            translate: (t) => t('menu_points.system_master_data_medical_health_insurances').ucFirst()
                                        },
                                        component: () => import("../views/pages/empty.vue"),
                                    }
                                ]
                            },

                            // -------------------------
                            // EESZT TÖRZSADATOK
                            // -------------------------
                            {
                                path: 'eeszt',
                                name: 'system-master-data-eeszt',
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                meta: {
                                    translate: (t) => t('menu_points.system_master_data_eeszt').ucFirst()
                                },
                                children: [
                                    {
                                        path: 'patient-identification-type',
                                        name: 'patient-identification-type',
                                        meta: {
                                            translate: (t) => {
                                                return t('menu_points.system_master_data_eeszt_patient_identification_type').ucFirst();
                                            },
                                        },
                                        component: () => import('../views/helpers/grouper/grouper.vue'),
                                        redirect: { name: 'patient-identification-type-list'},
                                        children: [
                                            {
                                                path: '',
                                                name: 'patient-identification-type-list',
                                                meta: {
                                                    translate: (t) => {
                                                        return t('menu_points.system_master_data_eeszt_patient_identification_type').ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/torTPaciensSzonositoTips/list.vue')
                                            },
                                            {
                                                path: 'create',
                                                name: 'patient-identification-type-create',
                                                meta: {
                                                    translate: (t) => {
                                                        return t('base.create_new_item', {item: t('menu_points.system_master_data_eeszt_patient_identification_type')}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/torTPaciensSzonositoTips/page.vue')
                                            },
                                            {
                                                path: ':id(\\d+)',
                                                name: 'patient-identification-type-edit',
                                                meta: {
                                                    translate: (t) => {
                                                        return t('base.edit_item', {item: t('menu_points.system_master_data_eeszt_patient_identification_type')}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/torTPaciensSzonositoTips/page.vue')
                                            },
                                        ]
                                    },
                                    {
                                        path: 'bno',
                                        name: 'bno',
                                        meta: {
                                            translate: (t) => {
                                                return t('menu_points.system_master_data_eeszt_bno').ucFirst();
                                            },
                                        },
                                        component: () => import('../views/helpers/grouper/grouper.vue'),
                                        redirect: { name: 'bno-list'},
                                        children: [
                                            {
                                                path: '',
                                                name: 'bno-list',
                                                meta: {
                                                    translate: (t) => {
                                                        return t('menu_points.system_master_data_eeszt_bno').ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/torBno105karakteres/list.vue')
                                            },
                                            {
                                                path: 'create',
                                                name: 'bno-create',
                                                meta: {
                                                    translate: (t) => {
                                                        return t('base.create_new_item', {item: t('menu_points.system_master_data_eeszt_bno')}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/torBno105karakteres/page.vue')
                                            },
                                            {
                                                path: ':id(\\d+)',
                                                name: 'bno-edit',
                                                meta: {
                                                    translate: (t) => {
                                                        return t('base.edit_item', {item: t('menu_points.system_master_data_eeszt_bno')}).ucFirst();
                                                    },
                                                },
                                                component: () => import('../views/pages/torBno105karakteres/page.vue')
                                            },
                                        ]
                                    }
                                ]
                            }
                        ]
                    },

                    // -------------------------
                    // FELHASZNÁLÓK
                    // -------------------------
                    {
                        path: 'users',
                        name: 'system-users',
                        component: () => import('../views/helpers/grouper/grouper.vue'),
                        meta: {
                            translate: (t) => t('menu_points.system_users').ucFirst()
                        },
                        children: [
                            {
                                path: 'nurses',
                                name: 'system-users-nurses',
                                meta: {
                                    translate: (t) => t('menu_points.system_users_nurses').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            },
                            {
                                path: 'doctors',
                                name: 'system-users-doctors',
                                meta: {
                                    translate: (t) => t('menu_points.system_users_doctors').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            },
                            {
                                path: 'users',
                                name: 'users',
                                meta: {
                                    translate: (t, tc) => {
                                        return tc('users.user', 2).ucFirst();
                                    },
                                },
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                redirect: { name: 'users-list'},
                                children: [
                                    {
                                        path: '',
                                        name: 'users-list',
                                        meta: {
                                            translate: (t, tc) => {
                                                return tc('users.user', 2).ucFirst();
                                            },
                                        },
                                        component: () => import('../views/pages/system/users/list.vue')
                                    },
                                    {
                                        path: 'create',
                                        name: 'user-create',
                                        meta: {
                                            translate: (t, tc) => {
                                                return t('base.create_new_item', {item: tc('users.user', 1)}).ucFirst();
                                            },
                                        },
                                        component: () => import('../views/pages/system/users/item.vue')
                                    },
                                    {
                                        path: ':id(\\d+)',
                                        name: 'user-edit',
                                        meta: {
                                            translate: (t, tc) => {
                                                return t('base.edit_item', {item: tc('users.user', 1)}).ucFirst();
                                            },
                                        },
                                        component: () => import('../views/pages/system/users/item.vue')
                                    },
                                ]
                            },
                        ]
                    },

                    // -------------------------
                    // INTÉZMÉNYEK
                    // -------------------------
                    {
                        path: 'institutions',
                        name: 'system-institutions',
                        meta: {
                            translate: (t) => t('menu_points.system_institutions').ucFirst()
                        },
                        component: () => import("../views/pages/empty.vue"),
                    },

                    // -------------------------
                    // RIPORTOK
                    // -------------------------
                    {
                        path: 'reports',
                        name: 'system-reports',
                        meta: {
                            translate: (t) => t('menu_points.system_reports').ucFirst()
                        },
                        component: () => import("../views/pages/empty.vue"),
                    },

                    // -------------------------
                    // RENDSZERÜZENETEK
                    // -------------------------
                    {
                        path: 'messages',
                        name: 'system-messages',
                        component: () => import('../views/helpers/grouper/grouper.vue'),
                        meta: {
                            translate: (t) => t('menu_points.system_messages').ucFirst()
                        },
                        children: [
                            {
                                path: 'messages',
                                name: 'system-messages-messages',
                                meta: {
                                    translate: (t) => t('menu_points.system_messages_messages').ucFirst()
                                },
                                component: () => import("../views/pages/empty.vue"),
                            }
                        ]
                    },

                    // -------------------------
                    // JOGOSULTSÁGKEZELÉS
                    // -------------------------
                    {
                        path: 'authorization',
                        name: 'system-authorization',
                        component: () => import('../views/helpers/grouper/grouper.vue'),
                        meta: {
                            translate: (t) => t('menu_points.system_authorization').ucFirst()
                        },
                        children: [

                            // Authorization structure
                            {
                                path: 'authorization-structure',
                                name: 'system-authorization-structure',
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                meta: {
                                    translate: (t) => t('menu_points.system_authorization_structure').ucFirst()
                                },
                                children: [
                                    // ----------------------------------------------------
                                    //                     PERMISSIONS
                                    // ----------------------------------------------------
                                    {
                                        path: 'permissions',
                                        name: 'permissions',
                                        meta: {
                                            translate: (t, tc) => tc('authorization::roles.role', 2).ucFirst(),
                                        },
                                        component: () => import('../views/helpers/grouper/grouper.vue'),
                                        redirect: { name: 'permissions-list' },
                                        children: [
                                            {
                                                path: '',
                                                name: 'permissions-list',
                                                meta: {
                                                    translate: (t, tc) => tc('authorization::roles.role', 2).ucFirst(),
                                                },
                                                component: () => import('../views/pages/system/authorization/roles/list.vue')
                                            },
                                            {
                                                path: 'create',
                                                name: 'permission-create',
                                                meta: {
                                                    translate: (t, tc) => t('base.create_new_item', { item: tc('authorization::roles.role', 1) }).ucFirst(),
                                                },
                                                component: () => import('../views/pages/system/authorization/roles/item.vue')
                                            },
                                            {
                                                path: ':id(\\d+)',
                                                name: 'permission-edit',
                                                meta: {
                                                    translate: (t, tc) =>
                                                        t('base.edit_item', { item: tc('authorization::roles.role', 1) }).ucFirst(),
                                                },
                                                component: () => import('../views/pages/system/authorization/roles/item.vue')
                                            },
                                        ]
                                    },

                                    // ----------------------------------------------------
                                    //                   ROLE GROUPS
                                    // ----------------------------------------------------
                                    {
                                        path: 'role-groups',
                                        name: 'role-groups',
                                        meta: {
                                            translate: (t, tc) => tc('authorization::role_groups.role_group', 2).ucFirst(),
                                        },
                                        component: () => import('../views/helpers/grouper/grouper.vue'),
                                        redirect: { name: 'role-groups-list' },
                                        children: [
                                            {
                                                path: '',
                                                name: 'role-groups-list',
                                                meta: {
                                                    translate: (t, tc) => tc('authorization::role_groups.role_group', 2).ucFirst(),
                                                },
                                                component: () => import('../views/pages/system/authorization/role-groups/list.vue')
                                            },
                                            {
                                                path: 'create',
                                                name: 'role-group-create',
                                                meta: {
                                                    translate: (t, tc) =>
                                                        t('base.create_new_item', { item: tc('authorization::role_groups.role_group', 1) }).ucFirst(),
                                                },
                                                component: () => import('../views/pages/system/authorization/role-groups/item.vue')
                                            },
                                            {
                                                path: ':id(\\d+)',
                                                name: 'role-group-edit',
                                                meta: {
                                                    translate: (t, tc) =>
                                                        t('base.edit_item', { item: tc('authorization::role_groups.role_group', 1) }).ucFirst(),
                                                },
                                                component: () => import('../views/pages/system/authorization/role-groups/item.vue')
                                            },
                                        ]
                                    },

                                    // ----------------------------------------------------
                                    //                 ROLE CATEGORIES
                                    // ----------------------------------------------------
                                    {
                                        path: 'role-categories',
                                        name: 'role-categories',
                                        meta: {
                                            translate: (t, tc) => tc('authorization::role_categories.role_category', 2).ucFirst(),
                                        },
                                        component: () => import('../views/helpers/grouper/grouper.vue'),
                                        redirect: { name: 'role-categories-list' },
                                        children: [
                                            {
                                                path: '',
                                                name: 'role-categories-list',
                                                meta: {
                                                    translate: (t, tc) => tc('authorization::role_categories.role_category', 2).ucFirst(),
                                                },
                                                component: () => import('../views/pages/system/authorization/role-categories/list.vue')
                                            },
                                            {
                                                path: 'create',
                                                name: 'role-category-create',
                                                meta: {
                                                    translate: (t, tc) =>
                                                        t('base.create_new_item', { item: tc('authorization::role_categories.role_category', 1) }).ucFirst(),
                                                },
                                                component: () => import('../views/pages/system/authorization/role-categories/item.vue')
                                            },
                                            {
                                                path: ':id(\\d+)',
                                                name: 'role-category-edit',
                                                meta: {
                                                    translate: (t, tc) =>
                                                        t('base.edit_item', { item: tc('authorization::role_categories.role_category', 1) }).ucFirst(),
                                                },
                                                component: () => import('../views/pages/system/authorization/role-categories/item.vue')
                                            },
                                        ]
                                    },

                                    // ----------------------------------------------------
                                    //                       MODULES
                                    // ----------------------------------------------------
                                    {
                                        path: 'modules',
                                        name: 'modules',
                                        meta: {
                                            translate: (t, tc) => tc('authorization::modules.module', 2).ucFirst(),
                                        },
                                        component: () => import('../views/helpers/grouper/grouper.vue'),
                                        redirect: { name: 'modules-list' },
                                        children: [
                                            {
                                                path: '',
                                                name: 'modules-list',
                                                meta: {
                                                    translate: (t, tc) => tc('authorization::modules.module', 2).ucFirst(),
                                                },
                                                component: () => import('../views/pages/system/authorization/modules/list.vue')
                                            },
                                            {
                                                path: 'create',
                                                name: 'module-create',
                                                meta: {
                                                    translate: (t, tc) =>
                                                        t('base.create_new_item', { item: tc('authorization::modules.module', 1) }).ucFirst(),
                                                },
                                                component: () => import('../views/pages/system/authorization/modules/item.vue')
                                            },
                                            {
                                                path: ':id(\\d+)',
                                                name: 'module-edit',
                                                meta: {
                                                    translate: (t, tc) =>
                                                        t('base.edit_item', { item: tc('authorization::modules.module', 1) }).ucFirst(),
                                                },
                                                component: () => import('../views/pages/system/authorization/modules/item.vue')
                                            },
                                        ]
                                    },
                                ]
                            },

                            // Permission management
                            {
                                path: 'permission-management',
                                name: 'system-authorization-permission-management',
                                component: () => import('../views/helpers/grouper/grouper.vue'),
                                meta: {
                                    translate: (t) => t('menu_points.system_authorization_permission_management').ucFirst()
                                },
                                children: [
                                    {
                                        path: 'individuals',
                                        name: 'individuals',
                                        meta: {
                                            translate: (t) =>
                                                t('menu_points.individuals').ucFirst(),
                                        },
                                        component: () => import('../views/pages/system/authorization/permissions/individual.vue')
                                    },
                                    {
                                        path: 'role-group',
                                        name: 'role group management',
                                        meta: {
                                            translate: (t) =>
                                                t('menu_points.role_group_management').ucFirst(),
                                        },
                                        component: () => import('../views/pages/system/authorization/permissions/role-group.vue'),
                                        // component: () => import('../views/pages/authorization/modules/item.vue')
                                    },
                                ]
                            }
                        ]
                    },

                    {
                        path: 'resource-monitor',
                        name: 'system-resource-monitor',
                        meta: {},
                        component: () => import('../views/pages/system/resource-monitor.vue')
                    },
                ]
            },
        ],
    },
    // A foglaló teljesen publikus felület: az időpont kiválasztása és a deeplink
    // feldolgozása nem igényel páciens-munkamenetet. A személyes adatok lépésében
    // maga a foglaló kéri be a belépést/regisztrációt, ezért nincs oldalsó menü és
    // nincs átirányítás a login oldalra.
    {
        path: "/appointment-booking",
        name: "appointment-booking",
        meta: {publicPage: true},
        component: () => import("../views/pages/appointmentBooking/page.vue"),
    },
    // Bejelentkezés NÉLKÜLI kérdőív-kitöltés a foglalási e-mail meghívó-linkjéről.
    // Az útvonal a `routes.php` aliason keresztül lokalizálható (a router beforeEach a
    // `routes.<fullPath>` fordítást alkalmazza); a backend a `public_fill.paths` szerint
    // építi a kiküldött linket, ezért a kettőnek egyeznie kell.
    {
        path: "/kitoltes/:token",
        name: "public-invited-fill",
        // Bejelentkezés nélkül elérhető: az axios-interceptor sem léptet ki innen 401-re
        // (a háttérben futó, auth-védett kérések — pl. lusta fordítás — nem jelentenek lejárt
        // munkamenetet, mert itt nincs is bejelentkezett felhasználó).
        meta: {publicPage: true},
        component: () => import("../views/pages/public/invited-fill.vue"),
    },
    // Bejelentkezés NÉLKÜLI jelszó-beállítás a pácienshez kiküldött linkről: a jelszó nélküli
    // regisztráció utáni fiók-aktiválás. A tokent a query hordozza (`?ActivationToken=`), mert a
    // backend így építi a linket, és a legacy mobil deep link is ezt az alakot várja — a
    // paraméter neve tehát szerződés. Az útvonalnak egyeznie kell a `PATIENT_ACTIVATION_URL`
    // végével, különben a kiküldött link üres oldalra visz.
    {
        path: "/activate",
        name: "public-patient-activation",
        // Mint a meghívó-linkes kitöltőnél: az axios-interceptor se léptessen ki 401-re, itt
        // ugyanis nincs bejelentkezett felhasználó.
        meta: {publicPage: true},
        props: {mode: "activation"},
        component: () => import("../views/pages/public/patient-account.vue"),
    },
    {
        path: "/reset-password",
        name: "public-patient-password-reset",
        meta: {publicPage: true},
        props: {mode: "reset"},
        component: () => import("../views/pages/public/patient-account.vue"),
    },
    // Felszabadult várólista-hely beváltása (#123): bejelentkezés nélkül, a levélben
    // kapott linkről. A token `?token=` query paraméterként érkezik — a
    // `WaitingListService::claimUrl()` ezt az alakot építi, ide is köti a végét.
    {
        path: "/waitlist/claim",
        name: "public-waiting-list-claim",
        meta: {publicPage: true},
        component: () => import("../views/pages/public/waiting-list-claim.vue"),
    },
    {
        path: "/login",
        name: "login",
        component: () => import("../views/pages/account/login"),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters["auth/loggedIn"]) {
                    // Redirect to the home page instead
                    next({name: "home"});
                } else {
                    // Continue to the login page
                    next();
                }
            },
        },
    },

    {
        path: "/register",
        name: "Register",
        component: () => import("../views/pages/account/register"),
        meta: {
            // Nyilvános oldal: ide a látogató bejelentkezés NÉLKÜL érkezik. Enélkül egy
            // 401/419 (pl. hiányzó munkamenet-süti) a hibakezelőn át a bejelentkezésre
            // dobná — a saját regisztrációja közben.
            publicPage: true,
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters["auth/loggedIn"]) {
                    // Redirect to the home page instead
                    next({name: "home"});
                } else {
                    // Continue to the login page
                    next();
                }
            },
        },
    },
    {
        path: "/forgot-password",
        name: "Forgot password",
        component: () => import("../views/pages/account/forgot-password"),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters["auth/loggedIn"]) {
                    // Redirect to the home page instead
                    next({name: "home"});
                } else {
                    // Continue to the login page
                    next();
                }
            },
        },
    },

    {
        path: "/error/404-basic",
        name: "error-404-basic",
        meta: {
            authRequired: true,
        },
        component: () => import("../views/pages/errors/404-basic"),
    },
    {
        path: "/error/404-cover",
        name: "error-404-cover",
        meta: {
            authRequired: true,
        },
        component: () => import("../views/pages/errors/404-cover"),
    },
    {
        path: "/error/500-basic",
        name: "error-500-basic",
        meta: {
            authRequired: true,
        },
        component: () => import("../views/pages/errors/500-basic"),
    },
    {
        path: "/error/500-cover",
        name: "error-500-cover",
        meta: {
            authRequired: true,
        },
        component: () => import("../views/pages/errors/500-cover"),
    },
];
